export const getCurrentTime = () => {
  let videoElList = document.getElementsByTagName('video')
  if (videoElList && videoElList.length > 0) {
    let videoEl = videoElList[0]
    return ~~videoEl.currentTime
  }
  return 0
}